import { callZpayFunction } from '../../callZpayFunction';

// 마켓팅용 이벤트 전송

export interface MarketingEventItem {
  shop_main_domain: string;
  product_no: string;
  product_item_id: string;
  quantity: number;
  price: number;
}
interface MarketingEventParam {
  item_list: MarketingEventItem[];
}

export const sendMarketingEvent = <T extends MarketingEventParam>(
  type: 'ADD_CART' | 'ADD_ORDER' | 'INITIATE_CHECKOUT',
  args: T
) => {
  const params = {
    ...args,
    item_list: args.item_list.map(({ shop_main_domain, ...item }) => ({
      ...item,
      product_no: shop_main_domain + '$' + item.product_no,
    })),
  };
  callZpayFunction('sendMarketingEvent')({ data: JSON.stringify({ type, ...params }) });
};
